module.exports = __webpack_public_path__ + "static/media/check-engine-light.15e2a5e7.svg";